import { useState } from "react";

// Локальный тип под валидационные ошибки, чтобы не тянуть типы из API
export type ValidationError = {
    errors?: Record<string, string[]>;
} | null;

export const useValidationErrors = () => {
    const [validationErrors, setValidationErrors] = useState<
        Record<string, string[]>
    >({});

    const setErrors = (error: ValidationError) => {
        if (error && (error as any).errors) {
            setValidationErrors(
                (error as any).errors as Record<string, string[]>
            );
        } else {
            setValidationErrors({});
        }
    };

    const getFieldError = (fieldName: string): string | null => {
        const errors = validationErrors[fieldName];
        return errors && errors.length > 0 ? errors[0] : null;
    };

    const hasFieldError = (fieldName: string): boolean => {
        return !!getFieldError(fieldName);
    };

    const clearErrors = () => {
        setValidationErrors({});
    };

    const clearFieldError = (fieldName: string) => {
        setValidationErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[fieldName];
            return newErrors;
        });
    };

    return {
        validationErrors,
        setErrors,
        getFieldError,
        hasFieldError,
        clearErrors,
        clearFieldError,
    };
};
